/**=========================================================
 * Module: reviews.js
 * Reviews Controller
 =========================================================*/

 App.controller('ReviewsController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D) {
   "use strict";

   $scope.type = 'translation';
   $scope.filter = '';

   $scope.data = [];

   $scope.page = {
           title: 'labels.REVIEWS',
           subTitle: ''
       };

    if($state.params.action=='video'){
        $scope.page.title = 'Training Videos';
        return
    }

   $scope.initialized = false;
   $scope.watchActivated = false;
   $scope.init = function(){

       if($rootScope.user.id && $rootScope.user.groupType=='CLIENT' && $rootScope.user.customRole=='REVIEWER'){
           $scope.initialized = true;

           $scope.table = {
               title: '',
               type: 'translation',
               filter: true,
               orderBy: 'code',
               order: 'desc',
               includedFields: ['id','review','status'],
               loadCallback: function(tableScope){
                for(let i=0; i<tableScope.data.length; i++){
                    tableScope.data[i].inReview = tableScope.data[i].status=='REVIEW'
                    $scope.data.push(tableScope.data[i]);
                }
               },
               fields: [
                   {
                       available: true,
                       hasLink: true,
                       name: 'pCode',
                       label: 'PROJECTCODE',
                       filterType: 'text',
                       filterValue: '',
                       orderable: true,
                       compareType: 'projectCode'
                   },{
                       available: true,
                       hasLink: true,
                       name: 'pName',
                       label: 'PROJECTNAME',
                       filterType: 'text',
                       filterValue: '',
                       orderable: true,
                       style: {
                           width: '400px'
                       }
                   },{
                       available: true,
                       name: 'inReview',
                       type: 'boolean'
                   }
               ],
               link: {
                   state: 'app.entity',
                   action: 'view',
                   type: 'translation',
                   filter: 'id'
               },
               loading: true
           };



                   

       } else {
           if(!$scope.watchActivated){
               $scope.watchActivated = true;
               $rootScope.$watch('user.id', function(){
                   if(!$scope.initialized){
                       $scope.init();
                   }
               });
           }
       }
   }

   $scope.init();

   $scope.$on('$destroy', function iVeBeenDismissed() {
     // say goodbye to your controller here
     // release resources, cancel request...
     $scope.load = function() { };
   });
}]);
